import { VIEW_DAY, VIEW_MONTH, VIEW_WEEK, VIEW_AGENDA, SERVICE_COLOR_PALETTE } from '@/lib/consts.ts'

export const CALENDAR_COLUMN_WIDTH = 250

export const CALENDAR_COLUMN_WIDTH_MOBILE = 100

export const CALENDAR_HOUR_SLOT_HEIGHT = 80

export const CALENDAR_MINUTE_SLOT_HEIGHT = CALENDAR_HOUR_SLOT_HEIGHT / 60

export const HEIGHT_STEP = 15 * CALENDAR_MINUTE_SLOT_HEIGHT

export const STEP = 5

export const CALENDAR_CARD_WIDTH = 249

export const CALENDAR_DRAWER_SHORT_WIDTH = 484

export const CALENDAR_WEEKDAY_COLUMN_WIDTH = 180

export const SIDEBAR_TIMELINE_WIDTH = 74

export const SIDEBAR_RESOURCE_WIDTH = 84

export const SIDEBAR_SINGLE_RESOURCE_WIDTH = SIDEBAR_TIMELINE_WIDTH + SIDEBAR_RESOURCE_WIDTH

export const SIDEBAR_FILTERS_WIDTH = 217

export const CARD_TYPES = {
  FUTURE: 'F',
  PAST: 'P',
  TODAY: 'T',
} as const

export const CALENDAR_SETTINGS = {
  DEFAULT_VIEW: 'default-view',
  FIT_WIDTH: 'fit-width',
  SERVICE_COLOR_PALETTE: 'service-color-palette',
} as const

export const DEFAULT_VIEW_SETTINGS = {
  DAILY: VIEW_DAY,
  WEEKLY: VIEW_WEEK,
  MONTHLY: VIEW_MONTH,
  AGENDA: VIEW_AGENDA,
} as const

export const WIDTH_MODE_SETTINGS = {
  FIT: 'fit',
  FIXED: 'fixed',
} as const

export const CALENDAR_SETTINGS_DEFAULT_MODEL = {
  [CALENDAR_SETTINGS.DEFAULT_VIEW]: DEFAULT_VIEW_SETTINGS.DAILY,
  [CALENDAR_SETTINGS.FIT_WIDTH]: WIDTH_MODE_SETTINGS.FIXED,
  [CALENDAR_SETTINGS.SERVICE_COLOR_PALETTE]: SERVICE_COLOR_PALETTE.VIVID,
} as const

export const CALENDAR_HOW_IT_WORKS = {
  DEFAULT_VIEW: 'default-view',
  DISPLAY_MODE: 'display-mode',
  WAITLIST: 'waitlist',
} as const

export const CALENDAR_CARD_ICONS_KEYS = {
  WARNING: 'warning',
  BOOST: 'boost',
  PAID: 'paid',
  NO_SHOW: 'no-show',
  NEEDS_CONFIRMATION: 'needs-confirmation',
  IS_BOOKSY_GIFT_CARD: 'is-booksy-gift-card',
  HAS_NOTE: 'has-note',
  IS_HIGHLIGHTED: 'is-highlighted',
  IS_CHOOSEN: 'is-choosen',
  IS_CANCELED: 'is-canceled',
  STAFFER_REQUESTED_BY_CLIENT: 'staffer-requested-by-client',
  PREPAYMENT_AWAITING: 'prepayment-awaiting',
} as const

export const ADD_EVENT_DROPDOWN_OPENING_SOURCE = {
  FAB: 'fab',
  CALENDAR_CONTENT: 'calendar-content',
} as const

export const CALENDAR_PERFORMANCE_MARKERS = {
  REFRESH_START: 'calendar-refresh-start',
  REFRESH_END: 'calendar-refresh-enf',
} as const

export const CALENDAR_PERFORMANCE_MEASURES = {
  REFRESH_MEAUSURE: 'calendar-refresh-measure',
} as const
